import algoliasearch from "algoliasearch";

const client = algoliasearch("BDAGJMRKK7", "9fcce486124d148c7888721dcb0f97c8", {
  protocol: "https:"
});
const index = client.initIndex("autoinfo");

export default index;
